/*
 * Public API Surface of highcharts-angular
 */

export { HighchartsChartComponent } from './lib/highcharts-chart.component';
export { HighchartsChartDirective } from './lib/highcharts-chart.directive';
export { provideHighcharts, providePartialHighcharts } from './lib/highcharts-chart.provider';
export { HighchartsConfig, PartialHighchartsConfig, ChartConstructorType } from './lib/types';
